var map = {
	"./backgroundHome1.png": "yIu9",
	"./backgroundHome2.png": "0mH7",
	"./backgroundHome3.png": "P+FG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k/9p";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/backgroundHome.*\.png$
// module id = k/9p
// module chunks = 13